module.exports = __webpack_public_path__ + "static/media/public_relations.a8888da2.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/public_relations.png
// module id = 499
// module chunks = 0